import { buildMessage, ValidateBy } from 'class-validator';
import { Duration } from 'luxon';
export function isDurationString(value, durationOptions) {
    return typeof value === 'string' && Duration.fromISO(value, durationOptions).isValid;
}
export function IsDurationString(durationOptions, validationOptions) {
    return ValidateBy({
        name: isDurationString.name,
        constraints: [durationOptions],
        validator: {
            validate(value, args) {
                return isDurationString(value, args?.constraints[0]);
            },
            defaultMessage: buildMessage((eachPrefix) => {
                return `${eachPrefix}$property is not a valid duration string`;
            }, validationOptions),
        },
    }, validationOptions);
}
//# sourceMappingURL=IsDurationString.js.map